import { MdArrowBackIos } from 'react-icons/md';
import styles from './megaMenu.module.scss';
import { COLORS } from 'utilities';
import { useContext, useState } from 'react';
import { GlobalContext } from 'context';
import { CategoryHierarchyType, CategoryVolumeEnum, ThemeEnum } from 'types';
import AppLinkComp from 'components/appLink/appLink.index';
import { catIconData } from 'data/categoryIcon';
import { PATH } from 'data/path';
import { Empty } from 'antd';
// import { TbCategory } from 'react-icons/tb';

const bulkPostSlug = '____BULK____POSTS____';

function MegaMenuComp({ className, categories }: { className?: string; categories?: CategoryHierarchyType[] }) {
    const [parent, setParent] = useState(categories?.length ? categories[0].slug : undefined);
    const { theme } = useContext(GlobalContext);
    const subCategory =
        parent === bulkPostSlug
            ? categories?.filter((i) => i.volume !== CategoryVolumeEnum.single)
            : categories?.filter((i) => i.volume !== CategoryVolumeEnum.multi).find((i) => i.slug === parent)?.children;

    return (
        <div className={`${styles['mega-menu-layout']} ${className ?? ''}`}>
            {categories ? (
                <div className="h-100 w-100 d-flex">
                    <div className={`${styles['right-menu']} h-100`}>
                        {/* <AppLinkComp href={PATH.bulkPosts()}>
                            <div
                                className={`${styles['items']} center-content-y justify-content-between pointer ${bulkPostSlug === parent ? styles['active'] : ''}`}
                                onMouseEnter={() => setParent(bulkPostSlug)}
                            >
                                <div className="center-content-y g-1">
                                    <TbCategory size={20} className="t-primary" />
                                    <p className="t-500 t-p2 t-l-black1">عمده فروشی</p>
                                </div>
                                <MdArrowBackIos
                                    size={16}
                                    color={
                                        bulkPostSlug === parent
                                            ? COLORS.primary
                                            : theme === ThemeEnum.light
                                              ? COLORS.black1
                                              : COLORS.gray3
                                    }
                                />
                            </div>
                        </AppLinkComp> */}
                        {categories
                            .filter((i) => i.volume !== CategoryVolumeEnum.multi)
                            .sort((a, b) => (b.order ?? 0) - (a.order ?? 0))
                            .map((item) => {
                                const Icon = catIconData.find((i) => i.key === item.icon);
                                return (
                                    <AppLinkComp href={PATH.posts({ category: item })} key={item.id}>
                                        <div
                                            className={`${styles['items']} center-content-y justify-content-between pointer
                                                ${item.slug === parent ? styles['active'] : ''}`}
                                            onMouseEnter={() => setParent(item.slug)}
                                        >
                                            <div className="center-content-y g-1">
                                                {Icon ? <Icon.icon size={20} className="t-primary" /> : null}
                                                <p className="t-400 t-p2 t-l-black1">{item.title}</p>
                                            </div>
                                            <MdArrowBackIos
                                                size={16}
                                                color={
                                                    item.slug === parent
                                                        ? COLORS.primary
                                                        : theme === ThemeEnum.light
                                                          ? COLORS.black1
                                                          : COLORS.gray3
                                                }
                                            />
                                        </div>
                                    </AppLinkComp>
                                );
                            })}
                    </div>
                    <div className={`w-100 ${styles['left-menu']}`}>
                        {subCategory?.length ? (
                            subCategory
                                .sort((a, b) => (b.order ?? 0) - (a.order ?? 0))
                                .map((category) => (
                                    <div key={category.id} className="mb-3">
                                        <AppLinkComp
                                            href={
                                                parent === bulkPostSlug
                                                    ? PATH.bulkPosts({ category })
                                                    : PATH.posts({ category })
                                            }
                                        >
                                            <p className="t-p1 t-400 t-l-black1 t-d-gray3 mb-2">{category.title}</p>
                                        </AppLinkComp>
                                        <div className="flex-column g-2">
                                            {category.children?.map((child) => (
                                                <AppLinkComp
                                                    href={
                                                        parent === bulkPostSlug
                                                            ? PATH.bulkPosts({ category })
                                                            : PATH.posts({ category: child })
                                                    }
                                                    key={child.id}
                                                >
                                                    <p className="t-p2 t-400 t-l-gray1 pointer">{child.title}</p>
                                                </AppLinkComp>
                                            ))}
                                        </div>
                                    </div>
                                ))
                        ) : (
                            <Empty
                                className="w-100 pv-6 flex-1 center-content flex-column"
                                description=" زیر دسته‌بندی ای یافت نشد..."
                            />
                        )}
                    </div>
                </div>
            ) : (
                <Empty
                    className="w-100 pv-6 flex-1 center-content flex-column m-0-i ph-0"
                    description="دسته‌بندی ای یافت نشد..."
                />
            )}
        </div>
    );
}

export default MegaMenuComp;
